import { render, staticRenderFns } from "./certificateTextEdit.vue?vue&type=template&id=5a4d4024&scoped=true&"
import script from "./certificateTextEdit.vue?vue&type=script&lang=js&"
export * from "./certificateTextEdit.vue?vue&type=script&lang=js&"
import style0 from "./certificateTextEdit.vue?vue&type=style&index=0&id=5a4d4024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4d4024",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
